<template functional>
  <div class="user-state-label-wrapper">
    <template v-if="props.status === $options.status()['已处理']">
      <i class="el-icon-circle el-icon-circle-check" style="background-color:#005bff"></i>
      <span style="color:#005bff">已处理</span>
    </template>
    <template v-else>
      <i class="el-icon-circle el-icon-remove-outline" style="background-color:#dadde0;"></i>
      <span style="color:#dadde0">待处理</span>
    </template>
  </div>
</template>

<script>
import { STATUS } from '../_eum';
export default {
  name: 'userStateLabel',
  props: {
    status: {
      type: String,
      required: true
    }
  },
  status() {
    return STATUS;
  }
};
</script>

<style lang="scss">
.user-state-label-wrapper {
  display: flex;
  align-items: center;
  // .state-label {
  //   height: 20px;
  //   width: 20px;
  //   padding: 2px;
  //   border-radius: 50%;
  //   line-height: 16px;
  i {
    margin-right: 9px;
  }
  // }
}
</style>
